var URI = require('urijs');
import LocaleHost from '../../../../scripts/classes/LocaleHost';

var FormBasic = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.$form = this.options.$el.find("form");
  this.$submitButton = this.options.$el.find("[data-circle-button]");

};

/**
 * Init
 * @return {[type]} [description]
 */
FormBasic.prototype.init = function(){

  var self = this;
    

  // submit button
  this.$form.on('onBeforeFormieSubmit', function(e) {

  	self.$submitButton.addClass("is-loading");

		//let data = e.detail;

    /*
    if (typeof MsCrmMkt !== "undefined" && self.options.$el.data('formHandle') == 'updatePreferences') {
      MsCrmMkt.MsCrmFormLoader.sendFormCaptureToCrm(e.currentTarget);
    }
    */

  });

  // set the language field that will be used for determining translations in email notifications
  var $formLanguageField = self.options.$el.find('[name="fields[formLanguage]"]');

  if ($formLanguageField.length) {
    var urlParams = new URLSearchParams(window.location.search);
    var formLanguageParam = urlParams.get('formLanguage');

    if (formLanguageParam) {
        $formLanguageField.val(formLanguageParam);
    } else {
      $formLanguageField.val(LocaleHost.getLocale(window.location.hostname) || 'en');
    }
  }

  this.options.$el.on('click', 'button.fui-next, button.fui-prev', function() {

    var newScrollTop = self.options.$el.offset().top - 32;
    var currScrollTop = document.documentElement.scrollTop;

    if (currScrollTop > newScrollTop) {

      window.scroll({
        top: newScrollTop, 
        behavior: 'smooth'
      });

    }

  });

};

export default  FormBasic;
